<template>
  <el-input class="common-search-input" size="small" :placeholder="placeholder"
            v-model="value" @keyup.enter.native="$emit('search', value)">
    <!--suppress JSUnresolvedVariable -->
    <i slot="suffix" class="el-icon-search" @click="$emit('search', value)"></i>
  </el-input>
</template>

<script>
export default {
  name: 'input-search',
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    }
    // @search
  },
  data () {
    return {
      value: ''
    }
  }
}
</script>

<style scoped>
  .el-icon-search {
    font-size: 18px;
  }
</style>

<style>
  .common-search-input .el-input__suffix {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/inputs/input-search.vue